/**
 * Type-safe query selector with null check
 */
export function $<T extends Element = HTMLElement>(
  selector: string,
  context: ParentNode = document,
): T | null {
  return context.querySelector<T>(selector);
}

/**
 * Type-safe query selector all - returns array
 */
export function $$<T extends Element = HTMLElement>(
  selector: string,
  context: ParentNode = document,
): T[] {
  return Array.from(context.querySelectorAll<T>(selector));
}

/**
 * Get element by ID with type safety
 */
export function byId<T extends HTMLElement = HTMLElement>(
  id: string,
): T | null {
  return document.getElementById(id) as T | null;
}

/**
 * Apply checkerboard pattern for transparent color display
 */
export function applyCheckerboardPattern(element: HTMLElement): void {
  element.classList.add("transparent-bg");
}

/**
 * Clear checkerboard pattern from element
 */
export function clearCheckerboardPattern(element: HTMLElement): void {
  element.classList.remove("transparent-bg");
}

/**
 * Safely add event listener with proper typing
 */
export function on<K extends keyof HTMLElementEventMap>(
  element: HTMLElement | null,
  event: K,
  handler: (ev: HTMLElementEventMap[K]) => void,
  options?: boolean | AddEventListenerOptions,
): void {
  element?.addEventListener(event, handler, options);
}

/**
 * Safely remove event listener
 */
export function off<K extends keyof HTMLElementEventMap>(
  element: HTMLElement | null,
  event: K,
  handler: (ev: HTMLElementEventMap[K]) => void,
  options?: boolean | EventListenerOptions,
): void {
  element?.removeEventListener(event, handler, options);
}
